<script>
import SrvAlbaranes from '@/services/srv-albaranes'

export default {
  methods: {
    generateStatus() {
      const empresa = this.$store.getters.getAutenticacion.empresa;
      // 
      var idioma = this.$i18n.locale.toUpperCase()
      const payload = {
        empresa: empresa,
        idioma: idioma,
        order: 'ASC'
      }
      // 
      return SrvAlbaranes.getEstadosPedidosWeb(payload).then(response => {
        this.$store.commit('setOrderStatus', response.data.estados)
        return response.data.estados;
      }).catch(error => {
        console.log('error: ' + error)
      })
    },
    getStatus() {
      if (this.$store.getters.getOrderStatus === undefined || this.$store.getters.getOrderStatus === null || this.$store.getters.getOrderStatus.length === 0) {
        return this.generateStatus().then(response => {
          return response
        })
      } else {
        return this.$store.getters.getOrderStatus
      }
    },

    getStatusWebCodeDescripcion(estadoPedidoWeb) {
      const todosLosEstados = this.$store.getters.getOrderStatus
      for (let i = 0; i < todosLosEstados.length; i++) {
        if (todosLosEstados[i].estadoPedidoWeb === estadoPedidoWeb) {
          return todosLosEstados[i].descripcion
        }
      }
      return estadoPedidoWeb
    },

    getStatusDescripcion(estadoPedido, estadoFabricacion) {
      const todosLosEstados = this.$store.getters.getOrderStatus
      for (let i = 0; i < todosLosEstados.length; i++) {
        if (todosLosEstados[i].estadoFabricacionExpert === estadoFabricacion && todosLosEstados[i].estadoPedidoExpert === estadoPedido) {
          return todosLosEstados[i].descripcion
        }
      }
      return '' + estadoPedido + '' + estadoFabricacion
    },
    getStatusWebCode(estadoFullExpert) {
      const estadoPedido = Math.floor(estadoFullExpert / 10)
      const estadoFabricacion = estadoFullExpert % 10
      const todosLosEstados = this.$store.getters.getOrderStatus
      for (let i = 0; i < todosLosEstados.length; i++) {
        if (todosLosEstados[i].estadoFabricacionExpert === estadoFabricacion && todosLosEstados[i].estadoPedidoExpert === estadoPedido) {
          return todosLosEstados[i].estadoPedidoWeb
        }
      }
      return -1
    },

    getStatusWebDescripcion(estadoWeb) {
      const estadoPedido = Math.floor(estadoWeb / 10)
      const estadoFabricacion = estadoWeb % 10

      return this.getStatusDescripcion(estadoPedido, estadoFabricacion)
    },

    getStatusExpertWebIcono(estadoPedido, estadoFabricacion) {
      const todosLosEstados = this.$store.getters.getOrderStatus
      for (let i = 0; i < todosLosEstados.length; i++) {
        if (todosLosEstados[i].estadoFabricacionExpert === estadoFabricacion && todosLosEstados[i].estadoPedidoExpert === estadoPedido) {
          return todosLosEstados[i].icono
        }
      }
      return null
    },

    getStatusWebIcono(estadoWeb) {
      const estadoPedido = Math.floor(estadoWeb / 10)
      const estadoFabricacion = estadoWeb % 10

      return this.getStatusExpertWebIcono(estadoPedido, estadoFabricacion)
    },

    getFullExpertStatusFromWebStatus(webStatus) {
      const returnValue = []
      const allStatus = this.$store.getters.getOrderStatus
      for (let i = 0; i < allStatus.length; i++) {
        if (allStatus[i].estadoPedidoWeb === webStatus) {
          returnValue.push(allStatus[i].estadoCompletoExpert)
        }
      }
      return returnValue
    },
    async loadAllOrderStatus() {
      let actualStatus
      const returnValue = []
      const allStatus = await this.getStatus();
      for (let i = 0; i < allStatus.length; i++) {
        actualStatus = {
          id: allStatus[i].estadoCompletoExpert,
          name: allStatus[i].descripcion
        }
        returnValue.push(actualStatus)
      }
      return returnValue
    },

    loadAllOrderWebStatusSync() {
      let actualStatus
      const values = []
      const returnValue = []
      const allStatus = this.$store.getters.getOrderStatus
      for (let i = 0; i < allStatus.length; i++) {
        actualStatus = {
          id: allStatus[i].estadoPedidoWeb,
          name: allStatus[i].descripcion
        }
        if (values.indexOf(actualStatus.id) === -1) {
          returnValue.push(actualStatus)
          values.push(actualStatus.id)
        }
      }
      returnValue.sort((a, b) => a.id - b.id);

      return returnValue
    },

    async loadAllOrderWebStatus() {
      let actualStatus
      const values = []
      const returnValue = []
      const allStatus = await this.getStatus()
      for (let i = 0; i < allStatus.length; i++) {
        actualStatus = {
          id: allStatus[i].estadoPedidoWeb,
          name: allStatus[i].descripcion
        }
        if (values.indexOf(actualStatus.id) === -1) {
          returnValue.push(actualStatus)
          values.push(actualStatus.id)
        }
      }
      return returnValue
    },
    getTotalWebStatus() {
      const values = []
      let returnValue = 0
      const allStatus = this.$store.getters.getOrderStatus
      for (let i = 0; i < allStatus.length; i++) {
        if (values.indexOf(allStatus[i].estadoPedidoWeb) === -1) {
          values.push(allStatus[i].estadoPedidoWeb)
          returnValue++
        }
      }
      return returnValue
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/globals/mx-estados.vue